<template>
    <initio-panel class="panel--declaration" @submit-handler="submitHandler" :errors="errors">
      <template v-slot:title>
        Renewal declaration
      </template>
      <template v-slot:sidebar>
        <initio-summary class="info-box" />
        <disclosure-block />
      </template>
    </initio-panel>
</template>

<script>

import InitioPanel from '@/components/initio/InitioPanel.vue'
import InitioSummary from '@/components/partials/Summary.vue'
import stepSubmit from '@/mixins/stepSubmit.js'
import { mapGetters } from 'vuex'
import DisclosureBlock from "../../partials/DisclosureBlock";

export default {
  components: {
    DisclosureBlock,
    InitioPanel,
    InitioSummary
  },
  mixins: [
    stepSubmit
  ],
  computed: {
    ...mapGetters({ answers: 'flattenedAnswers'}),
  },
  mounted () {

    this.$store.dispatch('getSchema', 'renew/vehicle-declaration' )
      .then(response => {
        this.$store.commit('updateSchema', response);
      })
  },
  methods: {
    submitHandler() {
      let context = this;

      this.genericSubmitHandler()
        .then(response => {
          // console.log(response)
        }, error => {
          // console.error(error)
          console.error("VehicleDeclaration Handler error", error); // Unsure if we need this or not, remove if not needed
          context.errors = error;
        });
    }
  },
  data () {
    return {
      errors: [],
      schema: []
    }
  }
}

</script>

<style lang="scss">
  .panel--declaration {
    .formulate-input[data-type=group] {
      background:#FAFAFA;
    }
  }
</style>